import { render } from "./ProductFeedbackHeader.vue?vue&type=template&id=3a669d21"
import script from "./ProductFeedbackHeader.vue?vue&type=script&lang=js"
export * from "./ProductFeedbackHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__